import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4.501 3.991v11.517c0 .129-.05.243-.15.343-.099.1-.216.149-.351.149a.481.481 0 0 1-.352-.15.472.472 0 0 1-.15-.342V3.99H0L4.009 0 8 3.991H4.501z"
    }, null, -1)
  ])))
}
export default { render: render }